import { Card, CardContent } from '../../../../components/ui/card'
import { Team } from '../../../../../app/entities/Team'

import { useAuth } from '../../../../../app/hooks/useAuth.ts'
import { EditTables } from './EditTables/index.tsx'
import { useMemo } from 'react'
import { useDefaultGoals } from '@/app/hooks/useDefaultGoals.ts'

export const TablesCard = ({ commissionV2, supervisor }: Team) => {
  const { isAdmin } = useAuth()
  const { isLoading } = useDefaultGoals()

  const { configuredTablesCount, totalTablesCount } = useMemo(() => {
    let configured = 0
    let total = 0

    commissionV2?.forEach((item) => {
      if (item.values && item.values.length > 0) {
        total += item.values.length
        configured += item.values.filter(
          () => (v: any) => v.seller > 0 || v.leader > 0 || v.supervisor > 0,
        ).length
      } else {
        total += 1
        if (
          (item.seller || 0) > 0 ||
          (item.leader || 0) > 0 ||
          (item.supervisor || 0) > 0
        ) {
          configured += 1
        }
      }
    })

    return { configuredTablesCount: configured, totalTablesCount: total }
  }, [commissionV2])

  const editableCommission = useMemo(() => {
    return commissionV2
  }, [commissionV2])

  return (
    <>
      {isAdmin && (
        <Card className="relative w-full">
          <CardContent className="space-y-2">
            <div className="flex items-center justify-between pt-4">
              <p className="text-xl font-semibold">Produtos</p>
              <p className="font-medium">
                {configuredTablesCount} / {totalTablesCount}
              </p>
            </div>
            <div className="w-full space-y-2">
              {!isLoading && (
                <EditTables
                  commission={editableCommission}
                  supervisorId={supervisor?._id}
                />
              )}
            </div>
          </CardContent>
        </Card>
      )}
    </>
  )
}
